import { render } from "./ProductDetailPhotosTab.vue?vue&type=template&id=96ad1420&ts=true"
import script from "./ProductDetailPhotosTab.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPhotosTab.vue?vue&type=script&lang=ts"

import "./ProductDetailPhotosTab.vue?vue&type=style&index=0&id=96ad1420&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__